// Module
var code = `<button
  id="btn-user-profile"
  data-type="auth0"
  data-event-type="toggleProfile"
  class="user-icon"
>
  <img width="20" src="{{picture}}" alt="" />
</button>

<div class="user-content">
  <div class="user-content-items">
<!--
    <img class="user-content-thumb" src="{{picture}}" alt="" />
-->
    <div class="user-content-name">
        <i class="fa-light fa-square-user"></i>
        <p class="user-name-text">{{name}}  <span class="user-content-role">{{roleName}}</span></p></div>



      <div class="user-role-button-container">
            {{roleButton}}

      </div>




      <button
              id="logout"
              data-type="auth0"
              data-event-type="logout"
      >
          <i class="fa-sharp fa-solid fa-arrow-right-from-bracket"></i><span>Logout</span>
      </button>


    <div class="auth-view-apps-list-container">
      <p class="auth-list-apps-title">SpyneJS Apps</p>
    </div>
  </div>

    <button
            id="btn-user-profile-bg"
            data-type="auth0"
            data-event-type="toggleProfile"
            class="user-content-bg"
    >
    </button>


</div>
`;
// Exports
module.exports = code;